let audioCtx;

export const playChime = () => {
  try {
    audioCtx = audioCtx || new (window.AudioContext || window.webkitAudioContext)();
    const now = audioCtx.currentTime;
    [880, 1320].forEach((freq, i) => {
      const osc = audioCtx.createOscillator();
      const gain = audioCtx.createGain();
      osc.type = "sine";
      osc.frequency.value = freq;
      gain.gain.setValueAtTime(0.0001, now + i * 0.09);
      gain.gain.exponentialRampToValueAtTime(0.18, now + i * 0.09 + 0.03);
      gain.gain.exponentialRampToValueAtTime(0.0001, now + i * 0.09 + 0.5);
      osc.connect(gain);
      gain.connect(audioCtx.destination);
      osc.start(now + i * 0.09);
      osc.stop(now + i * 0.09 + 0.55);
    });
  } catch (e) {
    /* audio not available */
  }
};

const COLORS = ["#1E40AF", "#FFD93D", "#5B21B6", "#FF8A3D", "#22C55E", "#D946A6"];

export const fireConfetti = (count = 90) => {
  for (let i = 0; i < count; i++) {
    const p = document.createElement("div");
    p.className = "confetti-piece";
    p.style.left = Math.random() * 100 + "vw";
    p.style.background = COLORS[Math.floor(Math.random() * COLORS.length)];
    p.style.animationDuration = 2.2 + Math.random() * 1.6 + "s";
    p.style.animationDelay = Math.random() * 0.25 + "s";
    p.style.width = 7 + Math.random() * 7 + "px";
    p.style.height = 10 + Math.random() * 10 + "px";
    document.body.appendChild(p);
    setTimeout(() => p.remove(), 4200);
  }
};

export const celebrate = () => {
  fireConfetti();
  playChime();
};
